import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, ButtonProps } from '@heroui/react';

export interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  title: string;
  message: string | React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmColor?: ButtonProps['color'];
  isLoading?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
  placement?: 'center' | 'auto' | 'top' | 'top-center' | 'bottom' | 'bottom-center';
  backdrop?: 'transparent' | 'opaque' | 'blur';
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  cancelLabel,
  confirmColor = 'danger',
  isLoading = false,
  size = 'md',
  placement = 'center',
  backdrop = 'blur',
}) => {
  const { t } = useTranslation('admin');

  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={size} placement={placement} backdrop={backdrop}>
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">{title}</ModalHeader>
        <ModalBody>{typeof message === 'string' ? <p>{message}</p> : message}</ModalBody>
        <ModalFooter>
          <Button variant="light" onPress={onClose} isDisabled={isLoading}>
            {cancelLabel || t('cancel')}
          </Button>
          <Button color={confirmColor} onPress={handleConfirm} isLoading={isLoading}>
            {confirmLabel || t('confirm')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmationModal;
